import React from 'react';
import ImportCSV from '../../components/import-csv';
import { CONSTANTS_REQ } from '../../utils/Constants';

const DeviceImport = (onSave: () => void) => {
    return <ImportCSV addedData={{ overwriteData: true }} url={CONSTANTS_REQ.DEVICE.IMPORT_CSV} save={onSave} />;
};

export default DeviceImport;
